@if (_text) {
  <div class="example-container">
    <div><strong>Example:</strong></div>
    <div>&emsp;{{ _text }}</div>
  </div>
}
